$(document).ready(function() {
    $(".accordion-head").click(function() {
      $(this).next('.accordion-body').slideToggle(300);
      $(this).toggleClass('acc_open');
    });
  });

// if (window.matchMedia("(max-width: 767px)").matches) {
// $('.feature-slideshow').slick({
//    slidesToShow: 1,
//    infinite:false,
//    slidesToScroll: 1,
//    autoplay: false,
//    dots: true,
//    arrows: false,
//   });
// }


function initializeSlider() {
  if (window.matchMedia("(max-width: 768px)").matches) {
    if (!$('.js-feature-slideshow').hasClass('flickity-enabled')) {
      $('.js-feature-slideshow').flickity({
        imagesLoaded: true,
        pageDots: true,
        watchCSS: true,
        prevNextButtons: false
      });
    }
  } else {
    if ($('.js-feature-slideshow').hasClass('flickity-enabled')) {
      $('.js-feature-slideshow').flickity('destroy');
    }
  }
}

// Debounce function to limit the rate of function calls
function debounce(func, wait) {
  let timeout;
  return function() {
    const context = this, args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

// Initialize slider on page load
$(document).ready(function() {
  initializeSlider();

  // Reinitialize slider on window resize with debounce
  $(window).resize(debounce(function() {
    initializeSlider();
  }, 100));
});
// $(".lightbox").fancybox({
//   backFocus: false,
//   trapFocus: false,
// });

